import { render } from "./HotLotComponent.vue?vue&type=template&id=669a6ef8"
import script from "./HotLotComponent.vue?vue&type=script&lang=js"
export * from "./HotLotComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/auctions/HotLotComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "669a6ef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('669a6ef8', __exports__)) {
    console.log('reload')
    api.reload('669a6ef8', __exports__)
  }
  
  module.hot.accept("./HotLotComponent.vue?vue&type=template&id=669a6ef8", () => {
    console.log('re-render')
    api.rerender('669a6ef8', render)
  })

}


export default __exports__